let User = {
    isLoggedIn: function(){
    	let isLoggedIn = (typeof window.qrllog !== 'undefined' && window.qrllog === '1')
    	isLoggedIn = isLoggedIn || ((typeof(window.DFPTargetKeys) !== 'undefined') && (parseInt(window.DFPTargetKeys.webSegVars.auth) > 0) )
    	return isLoggedIn;
        //return 
    }
};
export default User;